<template>
  <i class="icon" :class="['icon-'+ name, renderClassNames(addClass)]">
    <template v-if="name === 'location'">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <path fill="currentColor" d="M20,0c0.9,0,1.7,0.7,1.7,1.7l0,0v3.4c6.9,0.8,12.5,6.3,13.2,13.2l0,0h3.4c0.9,0,1.7,0.7,1.7,1.7s-0.7,1.7-1.7,1.7l0,0h-3.4
        c-0.8,6.9-6.3,12.5-13.2,13.2l0,0v3.4c0,0.9-0.7,1.7-1.7,1.7s-1.7-0.7-1.7-1.7l0,0v-3.4c-6.9-0.8-12.5-6.3-13.2-13.2l0,0H1.7
        C0.7,21.7,0,20.9,0,20s0.7-1.7,1.7-1.7l0,0h3.4c0.8-6.9,6.3-12.5,13.2-13.2l0,0V1.7C18.3,0.7,19.1,0,20,0z M20,8.3
        C13.6,8.3,8.3,13.6,8.3,20S13.6,31.7,20,31.7S31.7,26.4,31.7,20S26.4,8.3,20,8.3z M20,14.2c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8
        s-5.8-2.6-5.8-5.8S16.8,14.2,20,14.2z M20,17.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S21.4,17.5,20,17.5z"/>
      </svg>
    </template>
    <template v-else-if="name === 'filter'">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 41 40" enable-background="new 0 0 41 40" xml:space="preserve">
        <linearGradient :id="'filterGradient-' + randomString" gradientUnits="userSpaceOnUse" x1="-914.0694" y1="546.6659" x2="-915.7919" y2="547.9951" gradientTransform="matrix(40.2323 0 0 -39.9473 36839.082 21891.4805)">
          <stop  offset="0" style="stop-color:#0D92CD"/>
          <stop  offset="0.5" style="stop-color:#009999"/>
          <stop  offset="1" style="stop-color:#299958"/>
          <stop  offset="1" style="stop-color:#2B9955"/>
        </linearGradient>
        <path fill-rule="evenodd" clip-rule="evenodd"  :fill="'url(#filterGradient-' + randomString + ')'" d="M7.6,30.4
          c2.3,0,4.3,1.7,4.7,3.9l0,0h27c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9l0,0h-27C11.9,38.3,10,40,7.6,40s-4.3-1.7-4.7-3.9l0,0
          h-2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9l0,0h2C3.4,32.1,5.3,30.4,7.6,30.4z M7.6,31.8c-1.9,0-3.4,1.5-3.4,3.4
          c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4C11,33.3,9.5,31.8,7.6,31.8z M29.8,15c2.3,0,4.3,1.7,4.7,3.9l0,0h4.8
          c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9l0,0h-4.8c-0.4,2.2-2.4,3.9-4.7,3.9c-2.3,0-4.3-1.7-4.7-3.9l0,0H0.9
          c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9l0,0h24.2C25.5,16.7,27.5,15,29.8,15z M29.8,16.5c-1.9,0-3.4,1.5-3.4,3.4
          c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4C33.1,18,31.6,16.5,29.8,16.5z M16.9,0c2.3,0,4.3,1.7,4.7,3.9l0,0h17.7
          c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9l0,0H21.6c-0.4,2.2-2.4,3.9-4.7,3.9s-4.3-1.7-4.7-3.9l0,0H0.9C0.4,5.7,0,5.3,0,4.8
          c0-0.5,0.4-0.9,0.9-0.9l0,0h11.3C12.6,1.7,14.6,0,16.9,0z M16.9,1.5c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4
          c1.9,0,3.4-1.5,3.4-3.4C20.3,3,18.8,1.5,16.9,1.5z"/>
      </svg>
    </template>
    <template v-else-if="name === 'arrow-right-color'">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 40 29" enable-background="new 0 0 40 29" xml:space="preserve">
<linearGradient :id="'brandGradient-' + randomString" gradientUnits="userSpaceOnUse" x1="-914.1549" y1="535.5315" x2="-915.1448" y2="535.5315" gradientTransform="matrix(39.3625 0 0 -27.6775 36022.3867 14836.8545)">
	<stop  offset="0" style="stop-color:#2B9955"/>
  <stop  offset="1" style="stop-color:#0D92CD"/>
</linearGradient>
        <path :fill="'url(#brandGradient-' + randomString + ')'" d="M26.5,1.3c-0.5-0.6-1.4-0.6-2,0c-0.5,0.5-0.5,1.4,0,2l10.1,10.1H1.4c-0.8,0-1.4,0.6-1.4,1.4
	c0,0.8,0.6,1.4,1.4,1.4h33.2l-10.1,10c-0.5,0.6-0.5,1.4,0,2c0.6,0.6,1.4,0.6,2,0l12.4-12.4c0.6-0.5,0.6-1.4,0-2L26.5,1.3z"/>
</svg>

    </template>


    <template v-else-if="name === 'email-color'">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 40 36" enable-background="new 0 0 40 36" xml:space="preserve">
        <linearGradient :id="'brandGradient-' + randomString" gradientUnits="userSpaceOnUse" x1="-914.5351" y1="543.9709" x2="-915.525" y2="543.9709" gradientTransform="matrix(40 0 0 -35.8592 36621 19524.2734)">
          <stop  offset="0" style="stop-color:#2B9955"/>
          <stop  offset="1" style="stop-color:#0D92CD"/>
        </linearGradient>
                <path :fill="'url(#brandGradient-' + randomString + ')'" d="M34.6,28.5c0.2,0.1,0.3,0.3,0.4,0.5c0,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.2,0.2-0.3,0.3
          C34.4,30,34.3,30,34.1,30c-0.1,0-0.2,0-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1l-8.1-5.7H14.5l-8.1,5.7c-0.2,0.1-0.4,0.1-0.7,0.1
          c-0.2,0-0.4-0.1-0.5-0.3C5.1,29.5,5,29.3,5.1,29c0-0.2,0.2-0.4,0.3-0.5l8.3-5.9c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0h11.7
          c0.1,0,0.2,0,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1L34.6,28.5z M37.9,33.7c0.3-0.3,0.5-0.7,0.5-1.2V15.7l-8.7,5.9c-0.1,0.1-0.2,0.1-0.2,0.1
          c-0.1,0-0.2,0-0.2,0c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.2-0.1-0.4-0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.5l9-6L20,1.9
          L2.3,14.1l9,6c0.2,0.1,0.3,0.3,0.4,0.5c0,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2,0
          c-0.1,0-0.2,0-0.2-0.1l-8.7-5.9v16.8c0,0.5,0.2,0.9,0.5,1.2s0.7,0.5,1.2,0.5h33.3C37.1,34.1,37.5,34,37.9,33.7z M40,14.1v18.4
          c0,0.9-0.3,1.7-1,2.4c-0.7,0.7-1.4,1-2.4,1H3.4c-0.9,0-1.7-0.3-2.4-1c-0.7-0.7-1-1.4-1-2.4V14.1C0,14.1,0,14,0,14c0-0.1,0-0.1,0-0.1
          c0-0.1,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0v-0.1L19.5,0.2C19.7,0.1,19.8,0,20,0
          c0.2,0,0.3,0.1,0.5,0.2l19.1,13.4h0.1c0.1,0.1,0.1,0.1,0.2,0.2v0.1c0.1,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.2C40,14.1,40,14.1,40,14.1
          L40,14.1z"/>
      </svg>
    </template>

    <template v-else-if="name === 'phone-color'">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <linearGradient :id="'brandGradient-' + randomString" gradientUnits="userSpaceOnUse" x1="-914.5351" y1="547.525" x2="-915.525" y2="547.525" gradientTransform="matrix(40 0 0 -40 36621 21921)">
          <stop  offset="0" style="stop-color:#2B9955"/>
          <stop  offset="1" style="stop-color:#0D92CD"/>
        </linearGradient>
                <path :fill="'url(#brandGradient-' + randomString + ')'" d="M26.9,30.9c0.7-0.1,1.4-0.4,1.9-0.9l1.6-1.6c0.2-0.2,0.4-0.3,0.5-0.6c0.1-0.2,0.1-0.4,0.2-0.7
          c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.4-0.4-0.5L28,23.4c-0.3-0.3-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.2-1.2,0.6l-0.9,1
          c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-1.5-1.2-2.9-2.4-4.3-3.8c-1.4-1.4-2.6-2.7-3.8-4.2c-0.2-0.2-0.2-0.4-0.2-0.6
          c0-0.2,0.1-0.4,0.2-0.5l1-0.9c0.4-0.4,0.6-0.8,0.6-1.2c0-0.5-0.1-0.9-0.4-1.2l-2.6-2.6c-0.1-0.2-0.3-0.3-0.5-0.4C13.4,9,13.2,9,13,9
          c-0.3,0-0.5,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.6,0.4L10,11.2c-0.5,0.5-0.8,1.2-1,1.9c-0.1,0.7,0,1.4,0.3,1.9c1,1.6,2.1,3.1,3.2,4.5
          c1.2,1.4,2.4,2.8,3.7,4.1c1.3,1.3,2.7,2.6,4.1,3.7c1.4,1.2,2.9,2.3,4.5,3.2C25.5,31,26.2,31.1,26.9,30.9z M27.8,1.6
          c2.4,1.1,4.5,2.5,6.3,4.3c1.8,1.8,3.2,3.9,4.3,6.3c1.1,2.4,1.6,5,1.6,7.8c0,2-0.3,4-0.9,5.9c-0.6,1.9-1.5,3.7-2.6,5.4
          c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0-0.4,0-0.6-0.2c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.2,0-0.4,0.2-0.6c1-1.5,1.8-3.2,2.4-4.9
          c0.6-1.8,0.8-3.6,0.8-5.4c0-2.5-0.5-4.9-1.4-7.1C36,10.6,34.6,8.7,33,7c-1.7-1.7-3.6-3-5.8-3.9c-2.2-1-4.6-1.4-7.1-1.4
          c-2.5,0-4.9,0.5-7.1,1.4S8.7,5.4,7,7c-1.7,1.7-3,3.6-3.9,5.8S1.6,17.5,1.6,20s0.5,4.9,1.4,7.1S5.4,31.3,7,33c1.7,1.7,3.6,3,5.8,3.9
          c2.2,1,4.6,1.4,7.1,1.4c2.4,0,4.4-0.3,6-1c1.6-0.6,2.7-1.5,3.2-2.7c0.3-0.6,0.5-1.2,0.5-1.8c0-0.6,0-1.1-0.1-1.5
          c-0.5,0.4-1,0.7-1.6,0.9c-0.6,0.2-1.1,0.3-1.7,0.3c-0.4,0-0.9-0.1-1.2-0.2c-0.4-0.1-0.8-0.3-1.1-0.4c-1.6-1-3.2-2.1-4.6-3.3
          c-1.5-1.2-2.9-2.5-4.3-3.8c-1.4-1.4-2.6-2.8-3.8-4.3c-1.2-1.5-2.3-3-3.3-4.6c-0.5-0.9-0.7-1.9-0.6-3C7.6,11.8,8,10.8,8.8,10l1.6-1.6
          c0.6-0.7,1.4-1,2.4-1.1c1,0,1.8,0.2,2.4,0.8l2.6,2.7c0.6,0.6,0.9,1.4,0.9,2.4c0,1-0.4,1.8-1,2.4l-0.5,0.5c1,1.2,2.1,2.4,3.2,3.5
          c1.1,1.1,2.3,2.2,3.5,3.2l0.5-0.5c0.7-0.7,1.5-1,2.5-1.1c1,0,1.7,0.3,2.3,0.9l2.7,2.6c0.3,0.3,0.5,0.7,0.7,1.1
          c0.1,0.4,0.2,0.9,0.2,1.3c-0.1,0.4-0.2,0.9-0.3,1.3c-0.2,0.4-0.4,0.8-0.8,1.1L31,30.2c0.2,0.5,0.4,1.2,0.4,2.1
          c0.1,0.9-0.1,1.8-0.5,2.7c-0.5,1.1-1.5,2.3-3.1,3.4C26.2,39.5,23.6,40,20,40c-2.8,0-5.4-0.5-7.8-1.6c-2.4-1.1-4.5-2.5-6.3-4.3
          c-1.8-1.8-3.2-3.9-4.3-6.3C0.5,25.4,0,22.8,0,20s0.5-5.4,1.6-7.8c1.1-2.4,2.5-4.5,4.3-6.3c1.8-1.8,3.9-3.2,6.3-4.3
          C14.6,0.5,17.2,0,20,0C22.8,0,25.4,0.5,27.8,1.6L27.8,1.6z"/>
      </svg>
    </template>
  </i>
</template>

<script>
export default {
  name: "v-icon",
  data () {
    return {}
  },

  computed: {
    randomString () {
      return Math.random().toString(36).substring(7);
    }
  },

  methods: {
    renderClassNames (string) {
      if (string) {
        const iconsClasses = string.split(' ').map( className => {
          return 'icon-' + className
        })
        return iconsClasses
      } else {
        return ''
      }
    }
  },

  props: {
    name: String,
    addClass: String
  }
}
</script>

